// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids List Box Component */
:host {
  color: var(--ids-dropdown-color-text-default);
  cursor: var(--ids-cursor-pointer);
  display: block;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: 16px;
  line-height: 35px;
  outline: none;
  min-height: 32px;
  padding: 0;
  text-indent: 8px;
  user-select: none;
  min-width: calc(var(--ids-input-width-10) - 2px);
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
}

:host(.multiselect-option),
:host(.icon-option) {
  display: flex;
}
:host(.multiselect-option) ::slotted(ids-icon),
:host(.icon-option) ::slotted(ids-icon) {
  margin: 0;
  margin-inline-start: var(--ids-dropdown-space-text);
}

:host(.multiselect-loaded) {
  align-items: center;
}

:host([disabled]:not([disabled=false])) {
  cursor: var(--ids-cursor-default);
  opacity: 0.5;
  pointer-events: none;
}

:host(.is-selected:not(.multiselect-option)) {
  background-color: var(--ids-dropdown-color-background-selected);
  color: var(--ids-dropdown-color-text-selected);
  position: relative;
  z-index: 1;
}

:host(:hover:not(.is-selected):not([group-label]):not(.multiselect-option)),
:host(.is-focused),
:host(.multiselect-option:focus),
:host(.multiselect-option.is-selected),
:host(.multiselect-option:hover) {
  background-color: var(--ids-dropdown-color-background-hover);
  position: relative;
  z-index: 0;
}

::slotted(ids-icon) {
  vertical-align: middle;
  margin: 0 var(--ids-dropdown-space-text) 2px 0;
}

::slotted(ids-icon[dir=rtl]) {
  margin: 0 0 2px var(--ids-dropdown-space-text);
}

::slotted(ids-color) {
  vertical-align: middle;
  margin-inline-end: var(--ids-dropdown-space-text);
  position: relative;
  top: -1.5px;
}

::slotted(ids-check-box) {
  line-height: normal;
}

::slotted(.highlight) {
  display: contents;
  font-weight: var(--ids-font-weight-bold);
}

::slotted([slot=info]) {
  font-size: 12px;
  display: block;
  line-height: normal;
  padding-bottom: 8px;
  margin-top: -3px;
}

::slotted(span.multi-key:first-child) {
  display: inline-block;
  min-width: 100px;
  max-width: 100px;
}

:host([group-label]) {
  cursor: var(--ids-cursor-default);
  color: var(--ids-dropdown-group-color-text);
  font-weight: var(--ids-font-weight-semibold);
}

:host([group-label]:not(:first-child)),
:host(.multiselect-border) {
  border-top: 1px solid var(--ids-dropdown-group-color-border);
  margin-top: var(--ids-dropdown-group-padding);
}

:host(.module-nav) {
  color: var(--ids-module-nav-settings-menu-item-text-color);
  min-height: var(--ids-module-nav-item-height);
  padding-block: var(--ids-module-nav-switcher-dropdown-item-margin-block);
  position: relative;
  border-left: 4px solid transparent;
  transition: background-color 0.2s ease, border-left-color 0.2s ease;
  margin-bottom: 2px;
  border-radius: 0;
}

:host(.module-nav) ::slotted(ids-icon) {
  margin-inline-end: 8px;
  margin-block-end: 1px;
}

:host(.module-nav:hover) {
  background-color: var(--ids-module-nav-item-hover-bg-color);
  color: var(--ids-module-nav-item-hover-text-color);
}

:host(.module-nav.is-selected) {
  background-color: var(--ids-module-nav-item-hover-bg-color);
  color: var(--ids-module-nav-item-hover-text-color);
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-list-box/ids-list-box-option.scss"],"names":[],"mappings":"AAAA,2BAAA;AACA;EACE,6CAAA;EACA,iCAAA;EACA,cAAA;EACA,+EAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,aAAA;AACF;AACE;;EACE,SAAA;EACA,mDAAA;AAEJ;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,iCAAA;EACA,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,+DAAA;EACA,8CAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;;;;;EAKE,4DAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAGA;EACE,sBAAA;EACA,8CAAA;AAAF;;AAGA;EACE,8CAAA;AAAF;;AAGA;EACE,sBAAA;EACA,iDAAA;EACA,kBAAA;EACA,WAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,wCAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;AAAF;;AAIA;EACE,iCAAA;EACA,2CAAA;EACA,4CAAA;AADF;;AAIA;;EAEE,4DAAA;EACA,6CAAA;AADF;;AAIA;EACE,0DAAA;EACA,6CAAA;EACA,wEAAA;EACA,kBAAA;EACA,kCAAA;EACA,mEAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,sBAAA;EACA,qBAAA;AADF;;AAIA;EACE,2DAAA;EACA,kDAAA;AADF;;AAIA;EACE,2DAAA;EACA,kDAAA;EACA,UAAA;AADF","sourcesContent":["/* Ids List Box Component */\n:host {\n  color: var(--ids-dropdown-color-text-default);\n  cursor: var(--ids-cursor-pointer);\n  display: block;\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  font-size: 16px;\n  line-height: 35px;\n  outline: none;\n  min-height: 32px;\n  padding: 0;\n  text-indent: 8px;\n  user-select: none;\n  min-width: calc(var(--ids-input-width-10) - 2px);\n  text-overflow: ellipsis;\n  width: 100%;\n  white-space: nowrap;\n}\n \n:host(.multiselect-option),\n:host(.icon-option) {\n  display: flex;\n \n  ::slotted(ids-icon) {\n    margin: 0;\n    margin-inline-start: var(--ids-dropdown-space-text);\n  }\n}\n \n:host(.multiselect-loaded) {\n  align-items: center;\n}\n \n:host([disabled]:not([disabled='false'])) {\n  cursor: var(--ids-cursor-default);\n  opacity: 0.5;\n  pointer-events: none;\n}\n \n:host(.is-selected:not(.multiselect-option)) {\n  background-color: var(--ids-dropdown-color-background-selected);\n  color: var(--ids-dropdown-color-text-selected);\n  position: relative;\n  z-index: 1;\n}\n \n:host(:hover:not(.is-selected):not([group-label]):not(.multiselect-option)),\n:host(.is-focused),\n:host(.multiselect-option:focus),\n:host(.multiselect-option.is-selected),\n:host(.multiselect-option:hover) {\n  background-color: var(--ids-dropdown-color-background-hover);\n  position: relative;\n  z-index: 0;\n}\n \n// Style Icons when in the list\n::slotted(ids-icon) {\n  vertical-align: middle;\n  margin: 0 var(--ids-dropdown-space-text) 2px 0;\n}\n \n::slotted(ids-icon[dir='rtl']) {\n  margin: 0 0 2px var(--ids-dropdown-space-text);\n}\n \n::slotted(ids-color) {\n  vertical-align: middle;\n  margin-inline-end: var(--ids-dropdown-space-text);\n  position: relative;\n  top: -1.5px;\n}\n \n::slotted(ids-check-box) {\n  line-height: normal;\n}\n \n::slotted(.highlight) {\n  display: contents;\n  font-weight: var(--ids-font-weight-bold);\n}\n \n::slotted([slot='info']) {\n  font-size: 12px;\n  display: block;\n  line-height: normal;\n  padding-bottom: 8px;\n  margin-top: -3px;\n}\n \n::slotted(span.multi-key:first-child) {\n  display: inline-block;\n  min-width: 100px;\n  max-width: 100px;\n}\n \n// Group labels\n:host([group-label]) {\n  cursor: var(--ids-cursor-default);\n  color: var(--ids-dropdown-group-color-text);\n  font-weight: var(--ids-font-weight-semibold);\n}\n \n:host([group-label]:not(:first-child)),\n:host(.multiselect-border) {\n  border-top: 1px solid var(--ids-dropdown-group-color-border);\n  margin-top: var(--ids-dropdown-group-padding);\n}\n \n:host(.module-nav) {\n  color: var(--ids-module-nav-settings-menu-item-text-color);\n  min-height: var(--ids-module-nav-item-height);\n  padding-block: var(--ids-module-nav-switcher-dropdown-item-margin-block);\n  position: relative;\n  border-left: 4px solid transparent;\n  transition: background-color 0.2s ease, border-left-color 0.2s ease;\n  margin-bottom: 2px;\n  border-radius: 0;\n}\n \n:host(.module-nav) ::slotted(ids-icon) {\n  margin-inline-end: 8px;\n  margin-block-end: 1px;\n}\n \n:host(.module-nav:hover) {\n  background-color: var(--ids-module-nav-item-hover-bg-color);\n  color: var(--ids-module-nav-item-hover-text-color);\n}\n \n:host(.module-nav.is-selected) {\n  background-color: var(--ids-module-nav-item-hover-bg-color);\n  color: var(--ids-module-nav-item-hover-text-color);\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
